import React, { useState, useEffect, useRef } from 'react'
import {
    DropDownContainerBox,
    DropDownNavBtn,
    DropdownListContainer,
    BackgroundWrapper,
    DropdownArrow,
    DropdownList,
    DropdownHeader,
    DropdownContainer,
    ListItem,
    RemoveButton,
    LabelStyled
} from './Dropdown.styles'

import { useNavigate } from 'react-router-dom';

import DropdownIcon from '../../images/dropdownArrow.svg'

const Label = ({ name, label, marginBottom }) => (
    <LabelStyled htmlFor={name} marginBottom={marginBottom}>{label}</LabelStyled>

)

const CloseDropdown = ({ shouldRotate }) => (

    <DropdownArrow src={DropdownIcon} alt="dropdown-arrow" shouldRotate={shouldRotate} />
)

const Option = ({ id, showRemoveButton = false, itemPadding, itemHeight, letterSpacing, fontSize, fontWeight, textAlign, color, colorOnSelect, value, defaultSelect, innerText, onClick, isSelected, justifyContent, ...props }) => {
    return (<ListItem height={itemHeight} itemPadding={itemPadding} defaultSelect={defaultSelect} value={value}
        isSelected={isSelected}
        color={color}
        textAlign={textAlign}
        colorOnSelect={colorOnSelect}
        justifyContent={justifyContent}
        letterSpacing={letterSpacing}
        fontSize={fontSize}
        fontWeight={fontWeight}
        id={id}
        onClick={onClick}
        {...props}>


        {innerText}
        {(isSelected && showRemoveButton) && (
            <RemoveButton onClick={onClick} value={innerText} >&#10006;&#xFE0E;</RemoveButton>
        )}
    </ListItem>)
};

const Dropdown = ({
    hasFocus = false,
    handleMenuStateInternally = false,
    dropdownRef,
    maxHeight,
    currSelection,
    textAlign,
    justifyContent,
    justifyContentList,
    label,
    showLabel = false,
    showHeader = false,
    // listContainerRef,
    height,
    itemHeight = '40px',
    itemPadding,
    showRemoveButton,
    width,
    boxShadow,
    padding,
    _handleChange,
    border,
    background,
    listBackground,
    letterSpacing,
    fontSize,
    fontWeight,
    name,
    marginBottom,
    color,
    menuState,
    setMenuState,
    colorOnSelect,
    showArrow = false,
    dropdownListMarginTop,
    options, setState, handleStateChange = () => { }, valueX, key, id, handleOrderChange, ...props }) => {
    const listContainerRef = useRef(null)
    const [isOpen, setIsOpen] = useState(false);
    const [value, setValue] = useState(currSelection || valueX)
    const [currentVal, setCurrentVal] = useState(currSelection || valueX)
    const bgdRef = useRef(null)
    const initial = useRef(true);
    const handleChange = (event) => {

        setIsOpen(!isOpen)

    }

    useEffect(() => {
        if (initial.current) {
            initial.current = false;
            return;
        }
        if (!handleMenuStateInternally)
            setIsOpen(!isOpen)
    }, [])

    useEffect(() => {
        if (hasFocus && dropdownRef && dropdownRef.current)
            dropdownRef.current.focus()
    }, [hasFocus])

    useEffect(() => {
        if (listContainerRef.current)
            handleLongSuggestionsList()
    }, [currSelection])

    const handleLongSuggestionsList = () => {
        if (listContainerRef.current) {
            const activeIndex = options.findIndex(it => it.innerText === currSelection)
            // console.log("currSelection: ", activeIndex, Math.floor(parseInt(maxHeight) / parseInt(itemHeight)),
            // activeIndex % Math.floor(parseInt(maxHeight) / parseInt(itemHeight)) === 0,
            //     itemHeight * (activeIndex + 1), options.findIndex(it => it.innerText === currSelection))
            const { scrollHeight, offsetHeight } = listContainerRef.current
            if (scrollHeight > offsetHeight && (activeIndex % Math.floor(parseInt(maxHeight) / parseInt(itemHeight)) === 0))
                listContainerRef.current.scrollTop = parseInt(itemHeight) * (activeIndex)

        }
    }


    if (showHeader)
        return (<>
            {/* {isOpen && <BackgroundWrapper ref={bgdRef} onClick={(e) => { if (e.target === bgdRef.current && typeof (_handleChange) === 'function') _handleChange() }} />} */}
            {
                showLabel &&
                <Label
                    name={name}
                    label={label}
                    marginBottom={marginBottom}
                ></Label>
            }
            <DropdownContainer
                textAlign={textAlign}
                width={width}
                id={id}
                boxShadow={boxShadow}
                {...props}>

                <DropdownListContainer
                    background={background}
                    border={border}>
                    {
                        showHeader &&
                        <DropdownHeader
                            onClick={setMenuState ? setMenuState : () => setIsOpen(!isOpen)}
                            fontWeight={fontWeight}
                            {...props}
                        >{valueX || currSelection}
                            {showArrow && <CloseDropdown shouldRotate={menuState || isOpen} />}
                        </DropdownHeader>
                    }
                    <DropdownList
                        // ref={dropdownRef ? dropdownRef : undefined}
                        boxShadow={boxShadow}
                        ref={listContainerRef}
                        onFocus={
                            () => {
                                console.log("focus is here")
                            }
                        }
                        height={height}
                        listBackground={listBackground}
                        border={border}
                        marginTop={dropdownListMarginTop}
                        maxHeight={maxHeight}
                        justifyContent={justifyContentList}
                        padding={padding}
                    >
                        {
                            (((isOpen && handleMenuStateInternally) || (menuState && !handleMenuStateInternally))) &&
                            options.map(option => {
                                return (
                                    <Option
                                        id={option['id'] ? option['id'].replaceAll(' ', '-').toLowerCase() : undefined}
                                        itemHeight={itemHeight}
                                        itemPadding={itemPadding}
                                        color={color}
                                        letterSpacing={letterSpacing}
                                        fontSize={fontSize}
                                        fontWeight={fontWeight}
                                        textAlign={textAlign}
                                        colorOnSelect={colorOnSelect}
                                        justifyContent={justifyContent}
                                        value={option.value}
                                        showRemoveButton={showRemoveButton}
                                        innerText={option.innerText}
                                        key={option.value}
                                        defaultSelect={option.isDefault}
                                        onClick={(e) => {
                                            if (typeof (option['onClick']) === 'function')
                                                option.onClick(e)
                                            handleStateChange(e)
                                            if (handleMenuStateInternally)
                                                setIsOpen(!isOpen)
                                        }} //was selectNew
                                        isSelected={valueX ? valueX : currSelection ? currSelection === option.innerText : valueX.length ? valueX.includes(option.value) : false}
                                        {...option.props}
                                    />

                                )
                            })
                        }
                        <input ref={dropdownRef} id="dropdownRef" />
                    </DropdownList>
                </DropdownListContainer>



            </DropdownContainer>
        </>

        )
    return (<>
        {
            showLabel &&
            <Label
                name={name}
                label={label}
                marginBottom={marginBottom}
            ></Label>
        }
        <DropdownContainer
            textAlign={textAlign}
            width={width}
            id={id}
            boxShadow={boxShadow}
            {...props}>
            {menuState && (
                <DropdownListContainer

                    background={background}
                    border={border}>
                    {
                        showHeader &&
                        <DropdownHeader
                            onClick={handleChange}
                            fontWeight={fontWeight}
                            {...props}
                        >{valueX || currSelection}
                            {showArrow && <CloseDropdown shouldRotate={menuState || isOpen} />}
                        </DropdownHeader>
                    }
                    <DropdownList
                        boxShadow={boxShadow}
                        ref={listContainerRef}
                        onFocus={
                            () => {
                                console.log("focus is here")
                            }
                        }
                        height={height}
                        listBackground={listBackground}
                        border={border}
                        marginTop={dropdownListMarginTop}
                        maxHeight={maxHeight}
                        justifyContent={justifyContentList}
                        padding={padding}
                    >
                        {((isOpen && handleMenuStateInternally) || !handleMenuStateInternally) &&
                            options.map(option => {
                                return (
                                    <Option
                                        id={option['id'] ? option['id'].replaceAll(' ', '-').toLowerCase() : undefined}
                                        itemHeight={itemHeight}
                                        itemPadding={itemPadding}
                                        color={color}
                                        letterSpacing={letterSpacing}
                                        fontSize={fontSize}
                                        fontWeight={fontWeight}
                                        textAlign={textAlign}
                                        colorOnSelect={colorOnSelect}
                                        justifyContent={justifyContent}
                                        value={option.value}
                                        showRemoveButton={showRemoveButton}
                                        innerText={option.innerText}
                                        key={option.value}
                                        defaultSelect={option.isDefault}
                                        onClick={(e) => {
                                            if (typeof (option['onClick']) === 'function')
                                                option.onClick(e)
                                            handleStateChange(e)
                                            if (handleMenuStateInternally)
                                                setIsOpen(!isOpen)
                                        }} //was selectNew
                                        isSelected={valueX.length ? valueX.includes(option.value) : currSelection ? currSelection === option.innerText : false}
                                        {...option.props}
                                    />

                                )
                            })
                        }
                        <input ref={dropdownRef} id="dropdownRef" onFocus={() => console.log("focus is here")} />
                    </DropdownList>
                </DropdownListContainer>
            )}


        </DropdownContainer>
    </>)
}

export default Dropdown
